<div class="tab-pane" role="tabpanel" id="caract_proy_mod">
    <fieldset id="agregar_caract_proy_mod" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="form-horizontal">
                        <form [formGroup]="form">
                            <h3 class="form-signin-heading"><strong>Caracter&iacute;sticas del proyecto modificado</strong></h3>
                            <hr />
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <label for="lotes_proy_mod" class="col-md-2" align="left" style="padding-top: 20px;">Lotes resultantes</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nº" id="lotes_proy_mod" name="lotes_proy_mod" formControlName="lotes_proy_mod" >
                                    </mat-form-field>
                                </div>
                                <label for="mz_proy_mod" class="col-md-1" align="left" style="padding-top: 20px; margin-left: 20px">MZ</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px; margin-left: -35px">
                                        <input matInput placeholder="MZ" id="mz_proy_mod" name="mz_proy_mod" formControlName="mz_proy_mod" >
                                    </mat-form-field>
                                </div>
                                <label for="sup_proy_mod" class="col-md-1" align="left" style="padding-top: 20px; margin-left: 10px">Superficie</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px; margin-left: 10px">
                                        <input matInput placeholder="m2" id="sup_proy_mod" name="sup_proy_mod" formControlName="sup_proy_mod" >
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" style="padding-top: 20px">
                                <div class="col-md-1"></div>
                                <label for="hoja_anexa_mod" class="col-md-3" align="left" >Se adjunta hoja anexa (en caso de que sean mas lotes)</label>
                                <div>
                                    <mat-radio-group formControlName="hoja_anexa_mod">
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa_mod" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="hoja_anexa_mod" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-top: 30px ; padding-bottom: 10px" align="center">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="ingreso_lotes" (click)="add_caract_proy_mod()">
                                        Agregar Lotes
                                    <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            <div class="datatable_lotes">
                <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>LOTES RESULTANTES</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.lotes_proy_mod}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>MZ</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.mz_proy_mod}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>Superficie</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.sup_proy_mod}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column>
                        <ng-template ngx-datatable-header-template>
                            <span>OPCIONES</span>
                        </ng-template>
                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                            <span (click)="get_caract_proy_mod(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                            <span (click)="delete_caract_proy_mod(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                        </ng-template>
                    </ngx-datatable-column>

                </ngx-datatable>


            </div>
        </div>
    </fieldset>

    <ng-template #openModal>
        <h2 mat-dialog-title>Informaci&oacute;n de las caracteristicas principales del proyecto modificado</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-4 control-label" for="lotes_proy_mod">Lotes resultantes</label>
                    <div class="col-md-6">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_carct_proy_mod.id">
                        <input id="lotes_proy_mod" name="lotes_proy_mod" type="text" placeholder="num_anteproy_act" class="form-control input-md" [(ngModel)]="temp_carct_proy_mod.lotes_proy_mod">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="sup_anteproy_act">MZ</label>
                    <div class="col-md-6">
                        <input id="mz_proy_mod" name="mz_proy_mod" type="text" placeholder="MZ" class="form-control input-md" [(ngModel)]="temp_carct_proy_mod.mz_proy_mod">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="sup_anteproy_act">Superficie</label>
                    <div class="col-md-6">
                        <input id="sup_proy_mod" name="sup_proy_mod" type="text" placeholder="Sup" class="form-control input-md" [(ngModel)]="temp_carct_proy_mod.sup_proy_mod">
                    </div>
                    <div class="col-md-2"></div>
                </div>

            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_loteo" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id="ingreso_loteo" (click)="savecaract_proy_mod()">Ingresar Loteo <i class="fa fa-user-o " aria-hidden="true "></i></button>
        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>
<div class="separator"></div>